import * as React from "react";
import "./index.css";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CartProvider } from "./CartContext";

import App from "./App";
import Layout from "./layouts/Layout";
import AuthLayout from "./auth/Layout";
import Buy from "./pages/buy/index";
import Group from "./pages/customer/group";
import GroupManagement from "./pages/customer/group_management";
import UserList from "./pages/buy/customer_list";
import Reports from "./pages/reports/index";
import ReportsDaily from "./pages/reports/table/daily_sales_summary";
import SalesSummary from "./pages/reports/table/sales_summary";
import PurchasesSummary from "./pages/reports/table/purchases_summary";
import DailyPurchasesSummary from "./pages/reports/table/daily_purchases_summary";
import DashBoard from "./pages/reports/index";
// import ReportDetail from "./pages/reports/Detail";
import ReportDetail from "./pages/buy/components/report_summary_detail";
import Receipt from "./pages/receipt/receipt";
import BuyCheckout from "./pages/buy/buy";
import Equipment from "./pages/equipment";
import Home from "./pages/Home";
import reportWebVitals from "./reportWebVitals";
import Login from "./auth/Login";
import Register from "./auth/Register";
import CustomerForm from "./pages/customer/create";
import CustomerEdit from "./pages/customer/edit";
import TicketList from "./pages/ticket/ticket_list";
import Sale from "./pages/sale/index";
import SaleUserList from "./pages/saleCustomer/customer_list";
import SaleCheckout from "./pages/sale/sale";
import SaleTicketList from "./pages/ticket/sale_ticket_list";
import CustomerList from "./pages/customer/customer_list";
import PoManagement from "./pages/po";
import PoCreate from "./pages/po/create";
import PoEdit from "./pages/po/edit";
import SoManagement from "./pages/so";
import SoCreate from "./pages/so/create";
import SoEdit from "./pages/so/edit";
import Transform from "./pages/transform";
import Exchange from "./pages/transform/exchange";
import Stock from "./pages/stock";
// import Inventory from "./pages/inventory";
import Inventory from "./pages/inventory/stock";
import BeforeStock from "./pages/inventory/before_stock";


import LockPricing from "./pages/lockPricing";

import RequireRole from "./components/RequireRole";
import { AuthProvider } from "./contexts/AuthContext";
import IndividualPurchasesSummary from "./pages/reports/table/summary_individual_purchases";
import SummaryPurchasesProduct from "./pages/reports/table/summary_purchases_product";
import SummaryTicketPurchase from "./pages/reports/table/summary_ticket_purchases";
import CostInventory from "./pages/reports/table/cost_inventory";
import DailySalesSummary from "./pages/reports/table/daily_sales_summary";
import IndividualSalesSummary from "./pages/reports/table/summary_individual_sales";
import SummarySalesProduct from "./pages/reports/table/summary_sales_product";
import SummaryTicketSales from "./pages/reports/table/summary_ticket_sales";
import TopMonthlySalesPage from "./pages/reports/table/topMonthlySalesPage";
import TopMonthlyPurchasesPage from "./pages/reports/table/TopMonthlyPurchasesPage";

import SaleCustomerList from "./pages/sale/customer_list";
import SaleCustomerCreate from "./pages/saleCustomer/create";
import SaleCustomerEdit from "./pages/saleCustomer/edit";
import EditButton from "./pages/editButton/index";

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: Home,
          },
          {
            path: "/customers/create",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <CustomerForm />
              </RequireRole>
            ),
          },
          {
            path: "/customers/edit",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <CustomerEdit />
              </RequireRole>
            ),
          },
          {
            path: "/buy",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Buy />
              </RequireRole>
            ),
          },
          {
            path: "/buy/customers",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <UserList />
              </RequireRole>
            ),
          },
          {
            path: "/buy/checkout",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <BuyCheckout />
              </RequireRole>
            ),
          },
          {
            path: "/buy/ticket",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <TicketList />
              </RequireRole>
            ),
          },
          {
            path: "/sale",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Sale />
              </RequireRole>
            ),
          },
          {
            path: "/sale/customers",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleCustomerList />
              </RequireRole>
            ),
          },
          {
            path: "/sale-customers",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleUserList />
              </RequireRole>
            ),
          },
          {
            path: "/sale-customers/create",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleCustomerCreate />
              </RequireRole>
            ),
          },
           {
            path: "/sale-customers/edit",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleCustomerEdit />
              </RequireRole>
            ),
          },
          {
            path: "/sale/checkout",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleCheckout />
              </RequireRole>
            ),
          },
          {
            path: "/sale/ticket",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SaleTicketList />
              </RequireRole>
            ),
          },
          {
            path: "/customers",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <CustomerList />
              </RequireRole>
            ),
          },
          {
            path: "/customers",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <CustomerList />
              </RequireRole>
            ),
          },
          {
            path: "/customer_group",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Group />
              </RequireRole>
            ),
          },
          {
            path: "/customer_group/:group_id",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <GroupManagement />
              </RequireRole>
            ),
          },
          {
            path: "/reports",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Reports />
              </RequireRole>
            ),
          },
          {
            path: "/reports/daily",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Buy />
              </RequireRole>
            ),
          },
          {
            path: "/reports/sales",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SalesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/daily_purchases",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <DailyPurchasesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/individual_purchases",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <IndividualPurchasesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/summary_purchases_product",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SummaryPurchasesProduct />
              </RequireRole>
            ),
          },
          {
            path: "/reports/summary_ticket_purchases",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SummaryTicketPurchase />
              </RequireRole>
            ),
          },
          {
            path: "/reports/cost_inventory",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <CostInventory />
              </RequireRole>
            ),
          },
          {
            path: "/reports/daily_sales",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <DailySalesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/individual_sales",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <IndividualSalesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/summary_sales_product",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SummarySalesProduct />
              </RequireRole>
            ),
          },
          {
            path: "/reports/summary_ticket_sales",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SummaryTicketSales />
              </RequireRole>
            ),
          },
          {
            path: "/reports/purchases",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <PurchasesSummary />
              </RequireRole>
            ),
          },
          {
            path: "/reports/purchases/:transactionId",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <ReportDetail />
              </RequireRole>
            ),
          },
          {
            path: "/reports/top_monthly_sales",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <TopMonthlySalesPage />
              </RequireRole>
            ),
          },
           {
            path: "/reports/top_monthly_purchases",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <TopMonthlyPurchasesPage />
              </RequireRole>
            ),
          },
          {
            path: "/dashboard",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <DashBoard />
              </RequireRole>
            ),
          },
          {
            path: "/equipment",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Equipment />
              </RequireRole>
            ),
          },
          {
            path: "/po_management",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <PoManagement />
              </RequireRole>
            ),
          },
          {
            path: "/po_management/po_create",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <PoCreate />
              </RequireRole>
            ),
          },
          {
            path: "/po_management/po_edit",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <PoEdit />
              </RequireRole>
            ),
          },
          {
            path: "/so_management",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SoManagement />
              </RequireRole>
            ),
          },
          {
            path: "/so_management/so_create",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SoCreate />
              </RequireRole>
            ),
          },
          {
            path: "/so_management/so_edit",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <SoEdit />
              </RequireRole>
            ),
          },
          {
            path: "/lock_pricing",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <LockPricing />
              </RequireRole>
            ),
          },
          {
            path: "/stock",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Stock />
              </RequireRole>
            ),
          },
          {
            path: "/stock/inventory",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Inventory />
              </RequireRole>
            ),
          },
          {
            path: "/stock/before_stock",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <BeforeStock />
              </RequireRole>
            ),
          },   
          {
            path: "/stock/transform",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Transform />
              </RequireRole>
            ),
          },
          {
            path: "/stock/transform/exchange",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <Exchange />
              </RequireRole>
            ),
          },
          {
            path: "/edit_button",
            Component: () => (
              <RequireRole allowedRoles={[]}>
                <EditButton />
              </RequireRole>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
    ],
  },
  {
    path: "/",
    Component: AuthLayout,
    children: [
      {
        path: "/receipt/:transactionId",
        Component: Receipt,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
